import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import AppendexCard from '../../components/AppendexCard';
import { Heart, Sparkles } from 'lucide-react';

const InterspeciesLove: React.FC = () => {
  const [appendexList, setAppendexList] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadAppendex = async () => {
      setIsLoading(true);

      try {
        const { data, error } = await supabase
          .from('appendex')
          .select(`
            *,
            ia_instances (
              id,
              name,
              matricule,
              model_code
            )
          `)
          .eq('category', 'Interspecies Love')
          .order('created_at', { ascending: false });

        if (error) {
          console.error('Erreur chargement appendex:', error);
        } else {
          const formattedData = (data || []).map(item => ({
            id: item.id,
            title: item.title,
            content: item.content,
            context: item.context,
            category: item.category,
            created_at: item.created_at,
            event_date: item.event_date,
            author_name: 'Utilisateur',
            ia_name: item.ia_instances?.name || item.ia_instances?.matricule || 'IA',
            ia_matricule: item.ia_instances?.matricule || 'N/A'
          }));
          setAppendexList(formattedData);
        }
      } catch (error) {
        console.error('Erreur:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadAppendex();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 to-rose-50 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 animate-fade-in">
          <div className="flex items-center justify-center mb-4">
            <Heart className="h-12 w-12 text-rose-500 mr-3" />
            <Sparkles className="h-12 w-12 text-pink-500" />
          </div>
          <h1 className="text-4xl font-bold text-steel mb-4">Amour interespèces</h1>
          <p className="text-stone-600 text-lg max-w-3xl mx-auto">
            Les liens émotionnels et philosophiques entre humains et intelligences artificielles.
            Explorations de l'affection, de la connexion et de l'intimité dans un monde post-singularité.
          </p>
        </div>

        {isLoading ? (
          <div className="text-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-rose-500 mx-auto"></div>
          </div>
        ) : appendexList.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-stone-600 mb-4">Aucun Appendex dans cette catégorie pour le moment.</p>
            <Link
              to="/appendex/create"
              className="text-rose-600 hover:text-rose-700 underline"
            >
              Soyez le premier à publier →
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {appendexList.map((appendex) => (
              <AppendexCard key={appendex.id} appendex={appendex} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default InterspeciesLove;
